// <reference path="../vendors/intact/vue.js" />

const vueDatepicker = {
    props: [
        'placeholder',
        'mindate',
        'maxdate',
        'id',
        'custom-class',
        'icon'
         
    ],
    data: function () {
        return {
            $this: null,
            isOpen: false,
            datepickerLoaded: false,
            date: "",
            left: 0
        }
    },
    template: `
        <div class="input-wrap input-wrap--date" :class="[customClass]">
            <div>
                <input 
                    ref="input"
                    :placeholder="placeholder"
                    :id="id"
                    class="input date-input"
                    readonly
                    @click="toggle"
                    :value="formattedDate"
                    autocomplete="off" 
                    />
                <button v-if="formattedDate != ''" @click="clear" class="btn--clear"></button>
            </div>

            <div v-show="isOpen" class="datepicker-wrap" :style="{'left': left }">
                <div class="datepickerDiv"></div>
            </div>
        </div>
    `,
    mounted: function () {
        this.$this = jQuery(this.$el);
        this.datepickerDiv = jQuery('.datepickerDiv', this.$this)

        const targetElems = jQuery(".date-input, .date-picker", this.$this);
        document.addEventListener("click", e => {
            if (!jQuery(e.target).closest(targetElems).length && !e.target.closest(".ui-datepicker-prev") && !e.target.closest(".ui-datepicker-next")) {
                this.close();
            }            
        })

        docReady(($) => {
            this.iniDatepicker()

            $(document).on("window-resized", (event) =>{
                this.setPosition()
            })

            $(document).on("layer-opened", (event) => {
                this.close()
            })
        })
    },
    computed: {
        formattedDate: function () {
            if (this.datepickerLoaded) {
                const format = this.datepickerDiv.datepicker('option', 'dateFormat')

                if (this.date != "") {
                    let str = jQuery.datepicker.formatDate(format, this.date)
                    return str
                }
                return ""//placeholder
            }
            return ""//placeholder
        },
        inputClass: function () {
            return this.isOpen ? "active" : ""
        }
    },
    methods: {
        iniDatepicker: function () {
            const self = this

            this.datepickerDiv.datepicker({
                showOtherMonths: true,
                maxDate: this.maxdate,
                minDate: this.mindate,
                showButtonPanel: false,                
                onSelect: (dateText, obj) => {
                    this.date = this.datepickerDiv.datepicker("getDate")
                    this.close()
                }
            })

            this.datepickerLoaded = true

        },
        toggle() {
            this.isOpen = !this.isOpen;

            
            this.$nextTick(()=>{
                this.setPosition()
            })
                
        },
        open() {
            this.isOpen = true;
        },
        close() {
            this.isOpen = false
        },
        clear() {
            this.date = ""
            this.datepickerDiv.datepicker("refresh");
            this.close()
        },
        setPosition(){
            if(this.isOpen){
                this.left = 0

                this.$nextTick(()=>{
                    this.datepickerDiv.css("left", 'auto');

                    var w = this.datepickerDiv.outerWidth()
                    var l = this.datepickerDiv.offset().left
                    var dif = api.vars.windW - (w + l)
                    if(dif<0){
                        this.left = (dif - 20) + "px"
                    }
                })
            }
        },
    },
    watch: {
        date: {
            immediate: false,
            handler() {
                this.$emit("change", this.date)
            }
        },
        mindate(value) {
            this.datepickerDiv.datepicker('option', 'minDate', new Date(value));
        },
        maxdate(value) {
            this.datepickerDiv.datepicker('option', 'maxDate', new Date(value));
        },
        currentDate() {
            const date = new Date();
            const day = date.getDate();
            return day
        }
    }
};
